import React from 'react';
import {
  VStack,
  FormControl,
  FormLabel,
  Input,
  Switch,
  Select,
  HStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Checkbox,
  CheckboxGroup,
} from '@chakra-ui/react';
import ImageGallery from '../../components/ImageGallery';
import ColorPicker from '../../components/themeComponents/ColorPicker';

const DesignEditor = ({ formik, setActiveStep, navigate }) => {
  return (
    <form onSubmit={formik?.handleSubmit}>
      <VStack spacing={4}>
        {/* Campaign Name (Outside Tabs) */}
        <FormControl>
          <FormLabel>Campaign Name</FormLabel>
          <Input
            name="campaignName"
            value={formik?.values?.campaignName}
            onChange={formik?.handleChange}
          />
        </FormControl>

        {/* Tabs for Steps */}
        <Tabs variant="soft-rounded" colorScheme="blue" width="full">
          {
formik.values?.actionProps?.emailSubscriptionForm?.step2Fields?.enabled &&
          <TabList>
            <Tab>Step 1</Tab>
            <Tab>Step 2</Tab>
            <Tab>Step 3</Tab>
          </TabList>
          }
          <TabPanels>
            {/* Step 1: Existing Fields */}
            <TabPanel>
              <Accordion allowMultiple defaultIndex={[0]} width="full">
                {/* Heading */}
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Heading
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <VStack spacing={4}>
                      <FormControl>
                        <FormLabel>Heading Text</FormLabel>
                        <Input
                          name="actionProps.emailSubscriptionForm.heading.text"
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.heading?.text}
                          onChange={formik?.handleChange}
                        />
                      </FormControl>
                      <HStack spacing={4}>
                        <FormControl>
                          <FormLabel>Heading Color</FormLabel>
                          <ColorPicker
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.heading?.color}
                            onColorSelect={(val) =>
                              formik?.setFieldValue?.(
                                'actionProps.emailSubscriptionForm.heading.color',
                                val
                              )
                            }
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Color Mode</FormLabel>
                          <Select
                            name="actionProps.emailSubscriptionForm.heading.colorMode"
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.heading?.colorMode}
                            onChange={formik?.handleChange}
                          >
                            <option value="hex">Hex</option>
                            <option value="rgba">RGBA</option>
                          </Select>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Font Size</FormLabel>
                          <Input
                            name="actionProps.emailSubscriptionForm.heading.fontsize"
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.heading?.fontsize}
                            onChange={formik?.handleChange}
                            placeholder="e.g., 16px"
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Show Heading</FormLabel>
                          <Switch
                            name="actionProps.emailSubscriptionForm.heading.show"
                            isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.heading?.show}
                            onChange={formik?.handleChange}
                          />
                        </FormControl>
                      </HStack>
                    </VStack>
                  </AccordionPanel>
                </AccordionItem>

                {/* Subheading */}
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Subheading
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <VStack spacing={4}>
                      <FormControl>
                        <FormLabel>Subheading Text</FormLabel>
                        <Input
                          name="actionProps.emailSubscriptionForm.subheading.text"
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.subheading?.text}
                          onChange={formik?.handleChange}
                        />
                      </FormControl>
                      <HStack spacing={4}>
                        <FormControl>
                          <FormLabel>Subheading Color</FormLabel>
                          <ColorPicker
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.subheading?.color}
                            onColorSelect={(val) =>
                              formik?.setFieldValue?.(
                                'actionProps.emailSubscriptionForm.subheading.color',
                                val
                              )
                            }
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Color Mode</FormLabel>
                          <Select
                            name="actionProps.emailSubscriptionForm.subheading.colorMode"
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.subheading?.colorMode}
                            onChange={formik?.handleChange}
                          >
                            <option value="hex">Hex</option>
                            <option value="rgba">RGBA</option>
                          </Select>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Font Size</FormLabel>
                          <Input
                            name="actionProps.emailSubscriptionForm.subheading.fontsize"
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.subheading?.fontsize}
                            onChange={formik?.handleChange}
                            placeholder="e.g., 14px"
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Show Subheading</FormLabel>
                          <Switch
                            name="actionProps.emailSubscriptionForm.subheading.show"
                            isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.subheading?.show}
                            onChange={formik?.handleChange}
                          />
                        </FormControl>
                      </HStack>
                    </VStack>
                  </AccordionPanel>
                </AccordionItem>

                {/* Confirm Button */}
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Confirm Button
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <VStack spacing={4}>
                      <FormControl>
                        <FormLabel>Confirm Button Text</FormLabel>
                        <Input
                          name="actionProps.emailSubscriptionForm.confirmButton.content.text"
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.confirmButton?.content?.text}
                          onChange={formik?.handleChange}
                        />
                      </FormControl>
                      <HStack spacing={4}>
                        <FormControl>
                          <FormLabel>Text Color</FormLabel>
                          <ColorPicker
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.confirmButton?.content?.color}
                            onColorSelect={(val) =>
                              formik?.setFieldValue?.(
                                'actionProps.emailSubscriptionForm.confirmButton.content.color',
                                val
                              )
                            }
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Color Mode</FormLabel>
                          <Select
                            name="actionProps.emailSubscriptionForm.confirmButton.content.colorMode"
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.confirmButton?.content?.colorMode}
                            onChange={formik?.handleChange}
                          >
                            <option value="hex">Hex</option>
                            <option value="rgba">RGBA</option>
                          </Select>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Background Color</FormLabel>
                          <ColorPicker
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.confirmButton?.background?.color}
                            onColorSelect={(val) =>
                              formik?.setFieldValue?.(
                                'actionProps.emailSubscriptionForm.confirmButton.background.color',
                                val
                              )
                            }
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Show Confirm Button</FormLabel>
                          <Switch
                            name="actionProps.emailSubscriptionForm.confirmButton.show"
                            isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.confirmButton?.show}
                            onChange={formik?.handleChange}
                          />
                        </FormControl>
                      </HStack>
                    </VStack>
                  </AccordionPanel>
                </AccordionItem>

                {/* Consent Message */}
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Consent Message
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <VStack spacing={4}>
                      <FormControl>
                        <FormLabel>Consent Message</FormLabel>
                        <Input
                          name="actionProps.emailSubscriptionForm.consentMsg.text"
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.consentMsg?.text}
                          onChange={formik?.handleChange}
                        />
                      </FormControl>
                      <HStack spacing={4}>
                        <FormControl>
                          <FormLabel>Color</FormLabel>
                          <ColorPicker
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.consentMsg?.color}
                            onColorSelect={(val) =>
                              formik?.setFieldValue?.(
                                'actionProps.emailSubscriptionForm.consentMsg.color',
                                val
                              )
                            }
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Color Mode</FormLabel>
                          <Select
                            name="actionProps.emailSubscriptionForm.consentMsg.colorMode"
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.consentMsg?.colorMode}
                            onChange={formik?.handleChange}
                          >
                            <option value="hex">Hex</option>
                            <option value="rgba">RGBA</option>
                          </Select>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Font Size</FormLabel>
                          <Input
                            name="actionProps.emailSubscriptionForm.consentMsg.fontsize"
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.consentMsg?.fontsize}
                            onChange={formik?.handleChange}
                            placeholder="e.g., 15px"
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Show Consent</FormLabel>
                          <Switch
                            name="actionProps.emailSubscriptionForm.consentMsg.show"
                            isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.consentMsg?.show}
                            onChange={formik?.handleChange}
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Consent Status</FormLabel>
                          <Switch
                            name="actionProps.emailSubscriptionForm.consentMsg.status"
                            isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.consentMsg?.status}
                            onChange={formik?.handleChange}
                          />
                        </FormControl>
                      </HStack>
                    </VStack>
                  </AccordionPanel>
                </AccordionItem>

                {/* Cancel Button */}
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Cancel Button
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <VStack spacing={4}>
                      <FormControl>
                        <FormLabel>Cancel Button Text</FormLabel>
                        <Input
                          name="actionProps.emailSubscriptionForm.cancelButton.content.text"
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.cancelButton?.content?.text}
                          onChange={formik?.handleChange}
                        />
                      </FormControl>
                      <HStack spacing={4}>
                        <FormControl>
                          <FormLabel>Text Color</FormLabel>
                          <ColorPicker
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.cancelButton?.content?.color}
                            onColorSelect={(val) =>
                              formik?.setFieldValue?.(
                                'actionProps.emailSubscriptionForm.cancelButton.content.color',
                                val
                              )
                            }
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Color Mode</FormLabel>
                          <Select
                            name="actionProps.emailSubscriptionForm.cancelButton.content.colorMode"
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.cancelButton?.content?.colorMode}
                            onChange={formik?.handleChange}
                          >
                            <option value="hex">Hex</option>
                            <option value="rgba">RGBA</option>
                          </Select>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Background Color</FormLabel>
                          <ColorPicker
                            value={formik?.values?.actionProps?.emailSubscriptionForm?.cancelButton?.background?.color}
                            onColorSelect={(val) =>
                              formik?.setFieldValue?.(
                                'actionProps.emailSubscriptionForm.cancelButton.background.color',
                                val
                              )
                            }
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Show Cancel Button</FormLabel>
                          <Switch
                            name="actionProps.emailSubscriptionForm.cancelButton.show"
                            isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.cancelButton?.show}
                            onChange={formik?.handleChange}
                          />
                        </FormControl>
                      </HStack>
                    </VStack>
                  </AccordionPanel>
                </AccordionItem>

                {/* Logo */}
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Logo
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <HStack spacing={4}>
                      <FormControl>
                        <FormLabel>Show Logo</FormLabel>
                        <Switch
                          name="actionProps.emailSubscriptionForm.logo.show"
                          isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.logo?.show}
                          onChange={formik?.handleChange}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Logo Image</FormLabel>
                        <Input
                          name="actionProps.emailSubscriptionForm.logo.url"
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.logo?.url}
                          onChange={formik?.handleChange}
                        />
                        <ImageGallery
                          setImageData={(value) =>
                            formik?.setFieldValue?.(
                              'actionProps.emailSubscriptionForm.logo.url',
                              value?.mediaFileUrl
                            )
                          }
                          renderComponent={
                            <Text
                              cursor="pointer"
                              textDecoration="underline"
                              fontSize="0.8vw"
                            >
                              Add Image+
                            </Text>
                          }
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Logo Position</FormLabel>
                        <Select
                          name="actionProps.emailSubscriptionForm.logo.position"
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.logo?.position}
                          onChange={formik?.handleChange}
                        >
                          <option value="center">Center</option>
                          <option value="left">Left</option>
                          <option value="right">Right</option>
                        </Select>
                      </FormControl>
                    </HStack>
                  </AccordionPanel>
                </AccordionItem>

                {/* Background */}
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Background
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <HStack spacing={4}>
                      <FormControl>
                        <FormLabel>Background Color</FormLabel>
                        <ColorPicker
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.background?.color}
                          onColorSelect={(val) =>
                            formik?.setFieldValue?.(
                              'actionProps.emailSubscriptionForm.background.color',
                              val
                            )
                          }
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Color Mode</FormLabel>
                        <Select
                          name="actionProps.emailSubscriptionForm.background.colorMode"
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.background?.colorMode}
                          onChange={formik?.handleChange}
                        >
                          <option value="hex">Hex</option>
                          <option value="rgba">RGBA</option>
                        </Select>
                      </FormControl>
                    </HStack>
                  </AccordionPanel>
                </AccordionItem>

                {/* Redirect */}
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Redirect
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <HStack spacing={4}>
                      <FormControl>
                        <FormLabel>Redirect Status</FormLabel>
                        <Switch
                          name="actionProps.emailSubscriptionForm.redirect.status"
                          isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.redirect?.status}
                          onChange={formik?.handleChange}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Redirect URL</FormLabel>
                        <Input
                          name="actionProps.emailSubscriptionForm.redirect.url"
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.redirect?.url}
                          onChange={formik?.handleChange}
                          placeholder="https://example.com"
                        />
                      </FormControl>
                    </HStack>
                  </AccordionPanel>
                </AccordionItem>

                {/* Endpoint */}
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Endpoint
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <HStack spacing={4}>
                      <FormControl>
                        <FormLabel>Endpoint Status</FormLabel>
                        <Switch
                          name="actionProps.emailSubscriptionForm.endpoint.status"
                          isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.endpoint?.status}
                          onChange={formik?.handleChange}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Endpoint URL</FormLabel>
                        <Input
                          name="actionProps.emailSubscriptionForm.endpoint.url"
                          value={formik?.values?.actionProps?.emailSubscriptionForm?.endpoint?.url}
                          onChange={formik?.handleChange}
                          placeholder="https://api.example.com/submit"
                        />
                      </FormControl>
                    </HStack>
                  </AccordionPanel>
                </AccordionItem>

                {/* Animation */}
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Animation
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <FormControl>
                      <FormLabel>Animation</FormLabel>
                      <Input
                        name="actionProps.emailSubscriptionForm.animation"
                        value={formik?.values?.actionProps?.emailSubscriptionForm?.animation}
                        onChange={formik?.handleChange}
                        placeholder="e.g., fadeIn"
                      />
                    </FormControl>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </TabPanel>

            {/* Step 2: step2Fields */}
            <TabPanel>
              <Accordion allowMultiple defaultIndex={[0]} width="full">
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Step 2 Fields
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <VStack spacing={4}>
                      <FormControl>
                        <FormLabel>Enable Step 2</FormLabel>
                        <Switch
                          name="actionProps.emailSubscriptionForm.step2Fields.enabled"
                          isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.enabled}
                          onChange={formik?.handleChange}
                        />
                      </FormControl>
                      {formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.enabled && (
                        <>
                          {/* Step 2 Heading */}
                          <FormControl>
                            <FormLabel>Heading Text</FormLabel>
                            <Input
                              name="actionProps.emailSubscriptionForm.step2Fields.heading.text"
                              value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.heading?.text}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Heading Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.heading?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step2Fields.heading.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step2Fields.heading.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.heading?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                            <FormControl>
                              <FormLabel>Font Size</FormLabel>
                              <Input
                                name="actionProps.emailSubscriptionForm.step2Fields.heading.fontsize"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.heading?.fontsize}
                                onChange={formik?.handleChange}
                                placeholder="e.g., 35px"
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Show Heading</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step2Fields.heading.show"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.heading?.show}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                          </HStack>

                          {/* Step 2 Subheading */}
                          <FormControl>
                            <FormLabel>Subheading Text</FormLabel>
                            <Input
                              name="actionProps.emailSubscriptionForm.step2Fields.subheading.text"
                              value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.subheading?.text}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Subheading Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.subheading?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step2Fields.subheading.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step2Fields.subheading.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.subheading?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                            <FormControl>
                              <FormLabel>Font Size</FormLabel>
                              <Input
                                name="actionProps.emailSubscriptionForm.step2Fields.subheading.fontsize"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.subheading?.fontsize}
                                onChange={formik?.handleChange}
                                placeholder="e.g., 16px"
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Show Subheading</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step2Fields.subheading.show"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.subheading?.show}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                          </HStack>

                          {/* Step 2 Confirm Button */}
                          <FormControl>
                            <FormLabel>Confirm Button Text</FormLabel>
                            <Input
                              name="actionProps.emailSubscriptionForm.step2Fields.confirmButton.text"
                              value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.confirmButton?.text}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Text Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.confirmButton?.content?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step2Fields.confirmButton.content.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step2Fields.confirmButton.content.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.confirmButton?.content?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                            <FormControl>
                              <FormLabel>Background Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.confirmButton?.background?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step2Fields.confirmButton.background.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Show Confirm Button</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step2Fields.confirmButton.show"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.confirmButton?.show}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                          </HStack>

                          {/* Step 2 Consent Message */}
                          <FormControl>
                            <FormLabel>Consent Message</FormLabel>
                            <Input
                              name="actionProps.emailSubscriptionForm.step2Fields.consentMsg.text"
                              value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.consentMsg?.text}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.consentMsg?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step2Fields.consentMsg.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step2Fields.consentMsg.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.consentMsg?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                            <FormControl>
                              <FormLabel>Font Size</FormLabel>
                              <Input
                                name="actionProps.emailSubscriptionForm.step2Fields.consentMsg.fontsize"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.consentMsg?.fontsize}
                                onChange={formik?.handleChange}
                                placeholder="e.g., 15px"
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Show Consent</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step2Fields.consentMsg.show"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.consentMsg?.show}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Consent Status</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step2Fields.consentMsg.status"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.consentMsg?.status}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                          </HStack>

                          {/* Step 2 Cancel Button */}
                          <FormControl>
                            <FormLabel>Cancel Button Text</FormLabel>
                            <Input
                              name="actionProps.emailSubscriptionForm.step2Fields.cancelButton.text"
                              value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.cancelButton?.text}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Text Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.cancelButton?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step2Fields.cancelButton.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step2Fields.cancelButton.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.cancelButton?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                            <FormControl>
                              <FormLabel>Show Cancel Button</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step2Fields.cancelButton.show"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.cancelButton?.show}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                          </HStack>

                          {/* Step 2 Overlay Fields */}
                          <FormControl>
                            <FormLabel>Overlay Fields</FormLabel>
                            <CheckboxGroup
                              value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.overlayfields?.show || []}
                              onChange={(values) =>
                                formik?.setFieldValue?.(
                                  'actionProps.emailSubscriptionForm.step2Fields.overlayfields.show',
                                  values
                                )
                              }
                            >
                              <HStack spacing={4}>
                                <Checkbox value="name">Name</Checkbox>
                                <Checkbox value="email">Email</Checkbox>
                                <Checkbox value="phone">Phone</Checkbox>
                              </HStack>
                            </CheckboxGroup>
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Show Name Field</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step2Fields.overlayfields.name"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.overlayfields?.name}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Show Email Field</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step2Fields.overlayfields.email"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.overlayfields?.email}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Show Phone Field</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step2Fields.overlayfields.phone"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.overlayfields?.phone}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                          </HStack>

                          {/* Step 2 Fortune Wheel */}
                          <FormControl>
                            <FormLabel>Show Fortune Wheel</FormLabel>
                            <Switch
                              name="actionProps.emailSubscriptionForm.step2Fields.fortuneWheel.show"
                              isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.fortuneWheel?.show}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step2Fields.fortuneWheel.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.fortuneWheel?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                            <FormControl>
                              <FormLabel>Email Template UUID</FormLabel>
                              <Input
                                name="actionProps.emailSubscriptionForm.step2Fields.fortuneWheel.emailConfig.templateUuid"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.fortuneWheel?.emailConfig?.templateUuid}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Send Email</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step2Fields.fortuneWheel.emailConfig.sendEmail"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.fortuneWheel?.emailConfig?.sendEmail}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                          </HStack>
                          {/* Simplified Fortune Wheel Data (Dynamic List Placeholder) */}
                          <FormControl>
                            <FormLabel>Fortune Wheel Segments</FormLabel>
                            <Text fontSize="sm" color="gray.500">
                              Add/Edit segments (Label, Color, Coupon, etc.) via a dynamic form (TBD).
                            </Text>
                          </FormControl>

                          {/* Step 2 Claim Bar */}
                          <FormControl>
                            <FormLabel>Enable Claim Bar</FormLabel>
                            <Switch
                              name="actionProps.emailSubscriptionForm.step2Fields.claimBar.enabled"
                              isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.claimBar?.enabled}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <FormControl>
                            <FormLabel>Claim Bar Text</FormLabel>
                            <Input
                              name="actionProps.emailSubscriptionForm.step2Fields.claimBar.content.text"
                              value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.claimBar?.content?.text}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Text Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.claimBar?.content?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step2Fields.claimBar.content.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step2Fields.claimBar.content.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.claimBar?.content?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                            <FormControl>
                              <FormLabel>Percent Value</FormLabel>
                              <Input
                                name="actionProps.emailSubscriptionForm.step2Fields.claimBar.percent.value"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.claimBar?.percent?.value}
                                onChange={formik?.handleChange}
                                placeholder="e.g., 70"
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Percent Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.claimBar?.percent?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step2Fields.claimBar.percent.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                          </HStack>

                          {/* Step 2 Background */}
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Background Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.background?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step2Fields.background.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step2Fields.background.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step2Fields?.background?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                          </HStack>
                        </>
                      )}
                    </VStack>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </TabPanel>

            {/* Step 3: step3Fields */}
            <TabPanel>
              <Accordion allowMultiple defaultIndex={[0]} width="full">
                <AccordionItem>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      Step 3 Fields
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel sx={{ overflow: 'visible !important' }} pb={4}>
                    <VStack spacing={4}>
                      <FormControl>
                        <FormLabel>Enable Step 3</FormLabel>
                        <Switch
                          name="actionProps.emailSubscriptionForm.step3Fields.enabled"
                          isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.enabled}
                          onChange={formik?.handleChange}
                        />
                      </FormControl>
                      {formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.enabled && (
                        <>
                          {/* Step 3 Heading */}
                          <FormControl>
                            <FormLabel>Heading Text</FormLabel>
                            <Input
                              name="actionProps.emailSubscriptionForm.step3Fields.heading.text"
                              value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.heading?.text}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Heading Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.heading?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step3Fields.heading.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step3Fields.heading.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.heading?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                            <FormControl>
                              <FormLabel>Font Size</FormLabel>
                              <Input
                                name="actionProps.emailSubscriptionForm.step3Fields.heading.fontsize"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.heading?.fontsize}
                                onChange={formik?.handleChange}
                                placeholder="e.g., 30px"
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Show Heading</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step3Fields.heading.show"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.heading?.show}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                          </HStack>

                          {/* Step 3 Subheading */}
                          <FormControl>
                            <FormLabel>Subheading Text</FormLabel>
                            <Input
                              name="actionProps.emailSubscriptionForm.step3Fields.subheading.text"
                              value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.subheading?.text}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Subheading Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.subheading?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step3Fields.subheading.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step3Fields.subheading.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.subheading?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                            <FormControl>
                              <FormLabel>Font Size</FormLabel>
                              <Input
                                name="actionProps.emailSubscriptionForm.step3Fields.subheading.fontsize"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.subheading?.fontsize}
                                onChange={formik?.handleChange}
                                placeholder="e.g., 16px"
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Show Subheading</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step3Fields.subheading.show"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.subheading?.show}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                          </HStack>

                          {/* Step 3 Confirm Button */}
                          <FormControl>
                            <FormLabel>Confirm Button Text</FormLabel>
                            <Input
                              name="actionProps.emailSubscriptionForm.step3Fields.confirmButton.text"
                              value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.confirmButton?.text}
                              onChange={formik?.handleChange}
                            />
                          </FormControl>
                          <HStack spacing={4}>
                            <FormControl>
                              <FormLabel>Text Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.confirmButton?.content?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step3Fields.confirmButton.content.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Color Mode</FormLabel>
                              <Select
                                name="actionProps.emailSubscriptionForm.step3Fields.confirmButton.content.colorMode"
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.confirmButton?.content?.colorMode}
                                onChange={formik?.handleChange}
                              >
                                <option value="hex">Hex</option>
                                <option value="rgba">RGBA</option>
                              </Select>
                            </FormControl>
                            <FormControl>
                              <FormLabel>Background Color</FormLabel>
                              <ColorPicker
                                value={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.confirmButton?.background?.color}
                                onColorSelect={(val) =>
                                  formik?.setFieldValue?.(
                                    'actionProps.emailSubscriptionForm.step3Fields.confirmButton.background.color',
                                    val
                                  )
                                }
                              />
                            </FormControl>
                            <FormControl>
                              <FormLabel>Show Confirm Button</FormLabel>
                              <Switch
                                name="actionProps.emailSubscriptionForm.step3Fields.confirmButton.show"
                                isChecked={formik?.values?.actionProps?.emailSubscriptionForm?.step3Fields?.confirmButton?.show}
                                onChange={formik?.handleChange}
                              />
                            </FormControl>
                          </HStack>
                        </>
                      )}
                    </VStack>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </VStack>
    </form>
  );
};

export default DesignEditor;